import React, { useState, useEffect } from 'react';

interface ProgressBarProps {
  duration?: number; // Duration in milliseconds
  onComplete?: () => void;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ 
  duration = 3000, 
  onComplete 
}) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    console.log('ProgressBar started with duration:', duration);
    const startTime = Date.now();
    
    const updateProgress = () => {
      const elapsed = Date.now() - startTime;
      const newProgress = Math.min((elapsed / duration) * 100, 100);
      
      // console.log('Progress update:', newProgress);
      setProgress(newProgress);
      
      if (newProgress < 100) {
        requestAnimationFrame(updateProgress);
      } else {
        console.log('Progress completed');
        onComplete?.();
      }
    };
    
    requestAnimationFrame(updateProgress);
  }, [duration, onComplete]);

  console.log('Rendering progress:', progress);

  return (
    <div className="react-progress-bar">
      <div className="progress-track">
        <div 
          className="progress-fill-react"
          style={{ 
            width: `${progress}%`,
            minWidth: progress > 0 ? '2px' : '0px' // Ensure visibility
          }}
        />
      </div>
      <div className="progress-text">
        {Math.round(progress)}%
      </div>
    </div>
  );
};

export default ProgressBar;